// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ddyf","badges":"styles_badges__BDqaO"};